import React, { useRef, useEffect } from "react";
import SubheaderInPageLinks from "../SubheaderInPageLinks/SubheaderInPageLinks";
import Area from "../Area/Area";
import "./AreaPage.scss";

const AreaPage = () => {
    const areaLinkContainer = useRef();
    const areaViewport = useRef();
    const underViewport = useRef();

    //sections
    const overview = useRef();
    const trails = useRef();
    const area = useRef();
    const amenities = useRef();

    useEffect(() => {
        document.querySelector("#root").scrollTo(0, 0);
    }, []);

    return (
        <div className="area-page">
            <SubheaderInPageLinks
                areaLinkContainer={areaLinkContainer}
                underViewport={underViewport}
                overview={overview}
                trails={trails}
                area={area}
                amenities={amenities}
            ></SubheaderInPageLinks>
            <Area
                areaViewport={areaViewport}
                underViewport={underViewport}
                overview={overview}
                trails={trails}
                area={area}
                amenities={amenities}
            />
        </div>
    );
};

export default AreaPage;
